export default "/_next/static/images/teams-shape-51417795b5e206484ca0560110b1f612.svg";